export class SearchCondition {
  event_code: string = ""
  student_code: string = ""
  cram_code: string = ""
  name: string = ""
  nendo: string = ""
  grade: string = ""
  room_code: string = ""
  room_name: string = ""
  class_code: string = ""
  class_name: string = ""
  course_code: string = ""
  course_name: string = ""
  course_type: string = ""
  page: number = 1
  row_count: number =  100
}

export interface CramStudent {
  id: number
  student_code: number
  cram_code: number
  name: string
  nendo: number
  grade: number
  room_code_1: number
  room_name_1: string
  class_code_1: number
  class_name_1: string
  course_code_1: number
  course_name_1: string
  course_type_1: number
  level_1: string
  full_count: number
}

export interface Curriculum{
  id: number
  name: string
}
